<template>
  <div class="tabs top-to-bottom--effect">
    <div class="tabs__header">
      <div
        v-for="(tab, index) in pestanas"
        :key="tab.clave"
        @click="changeTab(tab.clave, index)"
        :class="[
          'tabs__header--option',
          { 'tabs__header--selected': tab.clave === selectedTitle }
        ]"
      >
        {{ tab.texto }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script setup>
  import { computed, ref, provide, useSlots, onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const slots = useSlots()
  const props = defineProps({
    backgroundColor: { type: String, default: 'transparent' },
    sliderChange: { type: Boolean, default: false },
    paddingHeader: { type: String, default: '0px' },
    /*
     * [{ clave, texto }]. La clave es con lo que cada Tab se reconoce -y tiene
     * que ser unica- y el texto es lo que se lee, ya traducido por quien lo
     * manda. Vacio: se sigue leyendo del slot y traduciendo, como siempre.
     */
    titulos: { type: Array, default: () => [] }
  })

  const delSlot = () =>
    slots
      .default()
      .map((tab) => tab.props && tab.props.title)
      .filter(Boolean)
      .map((title) => ({ clave: title, texto: t(title) }))

  const pestanas = computed(() =>
    props.titulos.length ? props.titulos : delSlot()
  )

  const selectedTitle = ref(pestanas.value.length ? pestanas.value[0].clave : null)
  const selectedIndex = ref(0)

  provide('selectedTitle', selectedTitle)

  const emit = defineEmits(['restartSlider', 'changeExperiences'])

  const changeTab = (title, index) => {
    selectedTitle.value = title
    selectedIndex.value = index
    emit('restartSlider', { title, index })
    emit('changeExperiences', { title, index })
  }

  onMounted(() => {
    changeTab(selectedTitle.value, selectedIndex.value)
  })
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .tabs {
    @include d-flex(column, flex-start, center);
    align-self: stretch;
    gap: 20px;
    flex: 1 0 0;
    &__header {
      @include d-flex(row, center, center);
      gap: 0px;
      align-self: stretch;
      padding: v-bind(paddingHeader);
      background-color: v-bind(backgroundColor);
      &--option {
        @include d-flex(row, center, center);
        width: 100%;
        padding: 10px;
        color: #6b6c6f;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        border-bottom: 3px solid var(--neutral-20);
        cursor: pointer;
      }
      &--selected {
        color: #0066ff;
        border-bottom: 3px solid #0066ff;
      }
    }
  }
</style>
